// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.descriptionbox{
    margin: 120px 70px;

}
.descriptionbox-navigator{
    display: flex;

}
.descriptionbox-nav-box{
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-weight: 600;
    width: 171px;
    height: 70px;
    border: 1px solid #d0d0d0;

}
.descriptionbox-nav-box.fade{
    background: #fbfbfb;
    color: #555;
}
.descriptionbox-description{
    display: flex;
    flex-direction: column;
    gap: 25px;
    border: 1px solid #D0D0D0;
    padding: 48px;
    padding-bottom: 70px;
}
@media(max-width:1280px){
    .descriptionbox{
        margin: 60px;
    }
}
@media(max-width:800px){
    .descriptionbox{
        margin: 60px 20px;
        
    }
    .descriptionbox-description{
        font-size: 14px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/Components/DescriptionBox/DescriptionBox.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;;AAEtB;AACA;IACI,aAAa;;AAEjB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,yBAAyB;;AAE7B;AACA;IACI,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,yBAAyB;IACzB,aAAa;IACb,oBAAoB;AACxB;AACA;IACI;QACI,YAAY;IAChB;AACJ;AACA;IACI;QACI,iBAAiB;;IAErB;IACA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".descriptionbox{\n    margin: 120px 70px;\n\n}\n.descriptionbox-navigator{\n    display: flex;\n\n}\n.descriptionbox-nav-box{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 16px;\n    font-weight: 600;\n    width: 171px;\n    height: 70px;\n    border: 1px solid #d0d0d0;\n\n}\n.descriptionbox-nav-box.fade{\n    background: #fbfbfb;\n    color: #555;\n}\n.descriptionbox-description{\n    display: flex;\n    flex-direction: column;\n    gap: 25px;\n    border: 1px solid #D0D0D0;\n    padding: 48px;\n    padding-bottom: 70px;\n}\n@media(max-width:1280px){\n    .descriptionbox{\n        margin: 60px;\n    }\n}\n@media(max-width:800px){\n    .descriptionbox{\n        margin: 60px 20px;\n        \n    }\n    .descriptionbox-description{\n        font-size: 14px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
